import React from "react";
import { Field } from "formik";

const hiddenFieldStyle = { display: "none" };

const FormBotProtection = () => (
  <div style={hiddenFieldStyle} aria-hidden="true">
    <Field
      name="company_website"
      type="text"
      autoComplete="off"
      tabIndex={-1}
    />
    <Field name="form_loaded_at" type="hidden" />
  </div>
);

export default FormBotProtection;
